export default __webpack_public_path__ + "static/media/office365.3ea2726d.svg";